var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"line-c3"},[_c('vue-c3',{attrs:{"handler":_vm.linecharthandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }